import React from "react"
import styled from "styled-components"

import { LARGE_SCREEN_MEDIA_QUERY } from "shared/helpers/responsive_helpers"

interface HeroProps {
  backgroundImage: string
  positionY: string
}

const Hero = styled.section<HeroProps>`
  background-image: linear-gradient( to bottom, rgba(225,225,225,0.8), rgba(225,225,225,0) ), url( ${ ( props ) => props.backgroundImage } );
  background-position-x: center;
  background-position-y: ${ ( props ) => props.positionY };
  background-size: cover;
  display: flex;
  height: calc( 100vh - 70px );
  justify-content: center;

  @media ${ LARGE_SCREEN_MEDIA_QUERY } {
    height: calc( 100vh - 100px );
  }
`

interface PageHeroProps {
  backgroundImage: string
  renderContent: () => React.ReactNode
  positionY: string
}

export const PageHero = ( { backgroundImage, renderContent, positionY }: PageHeroProps ) => (
  <Hero backgroundImage={ backgroundImage } positionY={ positionY }>
    <div className="px-4">
      { renderContent() }
    </div>
  </Hero>
)
